import {NgModule} from '@angular/core';
import {IonicModule} from 'ionic-angular';
import {CaptionInputModule} from '../caption.input.module';
import {CaptionInputModalComponent} from './caption-input-modal.component';

/**
 * Module for the CaptionInputModalModule
 * @class
 */
@NgModule({
  declarations: [CaptionInputModalComponent],
  entryComponents: [CaptionInputModalComponent],
  exports: [CaptionInputModalComponent],
  imports: [IonicModule, CaptionInputModule],
  providers: [],
})
export class CaptionInputModalModule {
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/caption/caption-input-modal/caption-input-modal.component.module.ts